export const ProcessingEndpoints = $api => {
  $api.register('processing', '/web/private/client', request => ({
    hesabPayment: payload => request('POST', '/payment/hesab/pay', payload),
    epointPayment: payload => request('POST', '/epoint/payment/incoming/pay', payload),
    epointPaymentAndCardRegistration: payload =>
      request('POST', '/epoint/payment/incoming/card-registration-and-pay', payload),
    epointCardAttachment: () => request('POST', '/payment-card-attachment-link/receive'),
  }));

  $api.register('processingSettings', '/web/public', request => ({
    incomingCardProvider: () => request('GET', '/settings/card-active-provider'),
  }));

  $api.register('commission', '/web/public', request => ({
    epointIncomingPayment: payload =>
      request('GET', `/epoint-split-commission/calculate/${payload}`),
  }));

  $api.register('wallet', '/web/private/client', request => ({
    change: payload => request('PUT', '/wallet/change', payload),
  }));
};
